import { ModuleRegistry } from '@ag-grid-community/core';

import { ServerSideRowModelModule } from '@ag-grid-enterprise/server-side-row-model';
import { ColumnsToolPanelModule } from '@ag-grid-enterprise/column-tool-panel';
import { SetFilterModule } from '@ag-grid-enterprise/set-filter';
import { ClipboardModule } from '@ag-grid-enterprise/clipboard';

export function useModuleSetup() {
    ModuleRegistry.registerModules([
        ServerSideRowModelModule,
        ColumnsToolPanelModule,
        SetFilterModule,
        ClipboardModule
    ]);
    return [
        ServerSideRowModelModule,
        ColumnsToolPanelModule,
        SetFilterModule,
        ClipboardModule
    ];
}